import React, { useEffect, createElement, Component } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Phone, Clock, MessageCircle } from 'lucide-react';
interface SuccessPageProps {
  formData?: {
    age?: string;
    goal?: string;
    state?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
  };
}
export function SuccessPage({
  formData
}: SuccessPageProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69e1236d5d1f0e7d13a4c53d');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const handleWhatsAppClick = () => {
    const message = `Hola! Acabo de completar el formulario de Life Freedom.

📋 Mis datos:
- Nombre: ${formData?.firstName || ''} ${formData?.lastName || ''}
- Edad: ${formData?.age || ''}
- Objetivo: ${formData?.goal || ''}
- Estado: ${formData?.state || ''}
- Teléfono: ${formData?.phone || ''}
- Email: ${formData?.email || ''}

Me gustaría continuar la conversación.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/13852507792?text=${encodedMessage}`, '_blank');
  };
  return <div className="w-full max-w-2xl mx-auto px-4 py-1 sm:py-6 space-y-4 sm:space-y-6" data-id="element-194">
      {/* Hero */}
      <div className="text-center" data-id="element-195">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full mb-3" data-id="element-196">
          <CheckCircle className="w-8 h-8 sm:w-10 sm:h-10 text-green-600" data-id="element-197" />
        </motion.div>
        <h1 className="text-xl sm:text-3xl font-bold text-dark mb-2" data-id="element-198">
          ¡Felicidades! Tu Solicitud Fue Recibida
        </h1>
        <p className="text-gray-500 text-sm sm:text-base font-medium" data-id="element-199">
          Estás a un paso de la estrategia financiera que usan los millonarios
        </p>
      </div>

      {/* Call Info Card */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="bg-primary rounded-xl p-5 text-white text-center shadow-lg" data-id="element-200">
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-201">
          <Phone className="w-5 h-5" data-id="element-202" />
          <span className="text-base sm:text-lg font-bold" data-id="element-203">
            📞 Te Llamaremos Pronto
          </span>
        </div>
        <div className="flex items-center justify-center gap-2 mt-3 bg-white/20 rounded-lg py-2 px-4 inline-flex mx-auto" data-id="element-204">
          <Clock className="w-4 h-4" data-id="element-205" />
          <span className="font-semibold text-sm" data-id="element-206">
            ⏰ Próximas 2 Horas Hábiles
          </span>
        </div>
        <p className="mt-3 text-white/90 text-sm" data-id="element-207">
          Un asesor certificado te contactará para tu consulta personalizada de
          30-45 minutos
        </p>
      </motion.div>

      {/* WhatsApp CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} data-id="element-208">
        <button onClick={handleWhatsAppClick} className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold text-base sm:text-lg py-4 px-6 rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center gap-3 hover:scale-[1.02] active:scale-[0.98]" data-id="element-209">
          <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-210" />
          Continúa la conversación por WhatsApp
        </button>
      </motion.div>

      {/* Bottom Message */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-blue-50 rounded-xl p-4 text-center border border-blue-100" data-id="element-211">
        <p className="font-bold text-sm text-dark mb-1" data-id="element-212">
          📱 Mantén tu teléfono cerca y con sonido activado
        </p>
        <p className="text-gray-600 text-xs" data-id="element-213">
          Si ves una llamada en las próximas 2 horas, probablemente somos
          nosotros.
        </p>
      </motion.div>
    </div>;
}